import { ROUTE_CONSTANTS } from 'constants/route';
import CountyCoveragePage from 'pages/CountyCoveragePage';
import CountyProfilePage from 'pages/CountyProfilePage';
import HomePage from 'pages/HomePage';
import InsurerPremiumByCountyPage from 'pages/InsurerPremiumByCountyPage';
import InsurerPremiumByCoveragePage from 'pages/InsurerPremiumByCoveragePage';
import InsurerProfilePage from 'pages/InsurerProfilePage';
import PremiumCoveragePage from 'pages/PremiumCoveragePage';
import PremiumTrendPage from 'pages/PremiumTrendPage';
import TransactionTypeComparisonPage from 'pages/TransactionTypeComparisonPage';
import CoverageCodeProfilePage from 'pages/CoverageCodeProfilePage';

const SiteRoutes = [
  {
    path: ROUTE_CONSTANTS.HOME,
    element: HomePage,
  },
  {
    path: ROUTE_CONSTANTS.COUNTY,
    element: CountyProfilePage,
    state: {
      pageName: 'County Profile',
    },
  },
  {
    path: `${ROUTE_CONSTANTS.COUNTY}/:countyId`,
    element: CountyProfilePage,
    state: {
      pageName: 'County Profile',
    },
  },
  {
    path: ROUTE_CONSTANTS.INSURER,
    element: InsurerProfilePage,
  },
  {
    path: `${ROUTE_CONSTANTS.INSURER}/:insurerId`,
    element: InsurerProfilePage,
  },
  {
    path: ROUTE_CONSTANTS.REPORT_PREMIUM_TREND,
    element: PremiumTrendPage,
  },
  {
    path: ROUTE_CONSTANTS.REPORT_INSURERS_PREMIUM_COUNTY,
    element: InsurerPremiumByCountyPage,
  },
  {
    path: ROUTE_CONSTANTS.REPORT_INSURERS_PREMIUM_COVERAGE,
    element: InsurerPremiumByCoveragePage,
  },
  {
    path: ROUTE_CONSTANTS.REPORT_COVERAGE_COUNTY,
    element: CountyCoveragePage,
  },
  {
    path: ROUTE_CONSTANTS.REPORT_COVERAGE_PREMIUM,
    element: PremiumCoveragePage,
  },
  {
    path: ROUTE_CONSTANTS.REPORT_TRANSACTION_TYPE_COMPARISON,
    element: TransactionTypeComparisonPage,
  },
  {
    path: ROUTE_CONSTANTS.COVERAGECODE,
    element: CoverageCodeProfilePage,
  },
];

export default SiteRoutes;
